"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSelfExclusionPeriods = void 0;
exports.defaultSelfExclusionPeriods = [
    1, 7, 30, 90, 180, 365, 730, 1825, 36600,
];
//# sourceMappingURL=selfExclusionPeriods.js.map